import { EventEmitter, Injectable, Output } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Event } from '../../shared/models/calendar/event';
import { AssignmentRules } from '../../shared/models/common/assigmentRules/assignmentRules';
import { LeadPotentialSeller } from '../../shared/models/lead/leadPotentialSeller';

@Injectable()
export class ModalsHandlerService {

  @Output() readonly deleteModal: EventEmitter<string[]> = new EventEmitter();
  @Output() readonly assignModal: EventEmitter<any> = new EventEmitter();
  @Output() readonly newLeadModal: EventEmitter<any> = new EventEmitter();
  @Output() readonly simulateLeadModal: EventEmitter<string> = new EventEmitter();
  @Output() readonly editLeadModal: EventEmitter<string> = new EventEmitter();
  @Output() readonly reloadLeads: EventEmitter<any> = new EventEmitter();
  @Output() readonly transferLeadModal: EventEmitter<any> = new EventEmitter();
  @Output() readonly viewHtmlLeadModal: EventEmitter<string> = new EventEmitter();
  @Output() readonly sendMailModal: EventEmitter<any> = new EventEmitter();
  @Output() readonly sendWhatsappModal: EventEmitter<any> = new EventEmitter();
  @Output() readonly trackLeadModal: EventEmitter<any> = new EventEmitter();
  @Output() readonly archivedLeadModal: EventEmitter<string[]> = new EventEmitter();
  @Output() readonly reminderModal: EventEmitter<any> = new EventEmitter();
  @Output() readonly closeLeadModal: EventEmitter<any> = new EventEmitter();
  @Output() readonly revertCloseLeadModal: EventEmitter<string> = new EventEmitter();
  @Output() readonly visitLeadModal: EventEmitter<any> = new EventEmitter();
  @Output() readonly callModal: EventEmitter<any> = new EventEmitter();
  @Output() readonly importCsvModal: EventEmitter<any> = new EventEmitter();
  @Output() readonly commentLeadModal: EventEmitter<string> = new EventEmitter();
  @Output() readonly calendarModal: EventEmitter<any> = new EventEmitter();
  @Output() readonly emailModal: EventEmitter<any> = new EventEmitter();
  @Output() readonly potentialSellersModal: EventEmitter<any> = new EventEmitter();
  @Output() readonly simulatedPotentialSellersModal: EventEmitter<any> = new EventEmitter();
  @Output() readonly createAssingmentRuleModal: EventEmitter<any> = new EventEmitter();
  @Output() readonly confirmModal: EventEmitter<any> = new EventEmitter();
  @Output() readonly confirmationModalResult: EventEmitter<boolean> = new EventEmitter();
  @Output() readonly editAssignmentRuleModal: EventEmitter<any> = new EventEmitter();

  openDeleteModal(ids: string[]): void {
    this.deleteModal.emit(ids);
  }

  openAssignModal(ids: string[], showComment?: boolean): void {
    this.assignModal.emit({ ids, showComment });
  }

  openNewLeadModal(): void {
    this.newLeadModal.emit();
  }

  openSimulateLeadModal(): void {
    this.simulateLeadModal.emit('simulation');
  }

  openCreateAssingmentRuleModal(): void {
    this.createAssingmentRuleModal.emit();
  }

  openEditLeadModal(id: string): void {
    this.editLeadModal.emit(id);
  }

  openTransferLeadodal(ids: string[], showComment?: boolean): void {
    this.transferLeadModal.emit({ ids, showComment });
  }

  openViewHtmlModal(id: string): void {
    this.viewHtmlLeadModal.emit(id);
  }

  openSendMailModal(contactName: string, leadId: string, hasMessage: boolean, createdAt: number, emailSubject?: string): void {
    this.sendMailModal.emit({ contactName, leadId, hasMessage, createdAt, emailSubject });
  }
  openWhatsappModal(contactPhone: string, leadId: string): void {
    this.sendWhatsappModal.emit({ contactPhone, leadId });
  }
  openTrackingLeadModal(onTrackStatus: string, leadId: string): void {
    this.trackLeadModal.emit({ onTrackStatus, leadId });
  }

  openArchivedLeadModal(leadsId: string[]): void {
    this.archivedLeadModal.emit(leadsId);
  }

  openCalendarModal(leadId: string, userId: string, inCall: boolean): void {
    this.calendarModal.emit({ leadId, userId, inCall });
  }
  openReminderModal(leadId: string, reminderDate?: number): void {
    this.reminderModal.emit({ leadId, reminderDate });
  }

  openCloseLeadModal(leadId: string, closeDate?: Date, comments?: string): void {
    this.closeLeadModal.emit({ leadId, closeDate, comments });
  }

  openRevertCloseLeadModal(leadId: string): void {
    this.revertCloseLeadModal.emit(leadId);
  }

  openVisitLeadModal(leadId: string, visitDate?: number): void {
    this.visitLeadModal.emit({ leadId, visitDate });
  }

  openCallModal(
    leadId: string,
    contactPhone: string,
    callStartTime?: string,
    needNextStep?: boolean,
    interactionTime?: number,
    userLeadId?: string,
    isTransitionNewToOnTrack?: boolean,
    eventToConfirm?: Event,
    comingFromCallModal?: boolean
  ): void {
    this.callModal.emit(
      {
        leadId,
        contactPhone,
        callStartTime,
        needNextStep,
        interactionTime,
        userLeadId,
        isTransitionNewToOnTrack,
        eventToConfirm,
        comingFromCallModal,
      }
    );
  }
  openImportLeadModal(): void {
    this.importCsvModal.emit();
  }

  openCommentLeadModal(leadId: string): void {
    this.commentLeadModal.emit(leadId);
  }

  openEmailModal(mail: SafeHtml): void {
    this.emailModal.emit(mail);
  }

  openPotentialSellersModal(id: string) {
    this.potentialSellersModal.emit(id);
  }

  openSimulatedPotentialSellersModal(potentialSellers: LeadPotentialSeller) {
    this.simulatedPotentialSellersModal.emit(potentialSellers);
  }

  openConfirmModal() {
    this.confirmModal.emit();
  }

  sendConfirmationModalResult(status: boolean) {
    this.confirmationModalResult.emit(status);
  }

  openEditAssignmentRuleModal(assignmentRule: AssignmentRules) {
    this.editAssignmentRuleModal.emit(assignmentRule);
  }
}
